import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=184da8fc"
import script from "./OtherSettings.vue?vue&type=script&lang=ts"
export * from "./OtherSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports